/**
 * Creates a object for every .Users DOM element.
 */
common.View.create('website::admin.websitePages.CreateEdit', {

	onDOMLoad()
	{
		this.initType();
	},

	initType()
	{
		this.element

			// Listen for type change.
			.find('input[name="type"]')
			.change(this.manageType.bind(this))
			.end();

		this.manageType();
	},

	manageType()
	{
		// Get selected type.
		let type = this.element.find('input[name="type"]:checked').val();

		this.element

            // Manage page title.
            .find('.titlePageWrapper')
                .toggleClass('hidden', type === 'redirect')
                .end()

			// Manage menu title.
			.find('input[name^="title_menu["]')
                .closest('.itemWrapper')
                    .each((i, element) => this.manageRequiredField(element, type === 'redirect'))
                    .end()
			    .end()

			// Manage slug.
			.find('input[name^="slug["]')
                .closest('.itemWrapper')
                    .toggleClass('hidden', type === 'redirect')
                    .end()
                .end()

			// Manage redirect.
			.find('input[name^="redirect["]')
                .closest('.itemWrapper')
                    .toggleClass('hidden', type !== 'redirect')
                    .each((i, element) => this.manageRequiredField(element, type === 'redirect'))
                    .end()
                .end()

            // Manage redirect wrapper for postback.
            .find('.redirectWrapper')
                .toggleClass('hidden', type !== 'redirect')
                .each((i, element) => this.manageRequiredField(element, type === 'redirect'))
                .end()

            // Target blank
            .find('input[name^="target_blank"]')
                .closest('.itemWrapper')
                    .toggleClass('hidden', type !== 'redirect')
                    .end()
                .end()

			// Manage headers + seo tabs.
			.find([
				'.nav-tabs .slider',
				'.nav-tabs .seo',
				'.tab-pane#slider',
				'.tab-pane#seo',
			].join(','))
			.toggleClass('hidden', type === 'redirect')
			.end()

			// Manage editors below.
			.find('.typeEditors .type')
			.each(function ()
			{
				$(this).toggleClass('hidden', $(this).data('type') !== type);
			})
			.end()
	},

    manageRequiredField(element, isRequired) {
        let h5Element = $(element)

            // (un)set input as required.
            .find('input[data-lang="' + $('html').attr('default-lang') + '"]')
                .attr('required', isRequired)
                .end()

            .find('h5')

            // Remove required, to start with.
            .find('.text-red-400')
                .remove()
                .end()

        let isSwitch = h5Element.closest('[class*="form-inputs"]')
            .hasClass('crud::form-inputs-Switch');

        // Add (again)?
        if (isRequired && !isSwitch) {
            h5Element.append('<span class="text-red-400">*</span>');
        }
    },
});
